// extracted by mini-css-extract-plugin
export default {"item-container":"accidentitem_item-container__CX-LP","title":"accidentitem_title__wZY9f","icon":"accidentitem_icon__VkvhL"};